// PlayerContext.js
import React, { createContext, useState } from 'react';

const PlayerContext = createContext();

export const PlayerProvider = ({ children }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    setIsPlaying(true);
  };
  const togglePause = () => {
    setIsPlaying(false);
  };

  return (
    <PlayerContext.Provider value={{ isPlaying, togglePlay, togglePause, setIsPlaying }}>
      {children}
    </PlayerContext.Provider>
  );
};

export const usePlayer = () => {
  return React?.useContext(PlayerContext);
};
